import { render } from "./z-screen.vue?vue&type=template&id=a5fc510a"
import script from "./z-screen.vue?vue&type=script&lang=js"
export * from "./z-screen.vue?vue&type=script&lang=js"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__